import { useEffect } from 'react';
import { isInIgnoredRouteTypes } from './isInIgnoredRouteTypes';
export function useScrollRestore({ location, ignoreForRouteTypes }) {
    useEffect(() => {
        if (ignoreForRouteTypes &&
            isInIgnoredRouteTypes({ location, routeTypes: ignoreForRouteTypes })) {
            return;
        }
        window.scrollTo(0, 0);
    }, [ignoreForRouteTypes, location]);
}
//# sourceMappingURL=useScrollRestore.js.map